<script lang="typescript">
  import { useMachine } from '@xstate/svelte';
  import type { MeetingType } from '../common/types';
  import TypeForm from './TypeForm.svelte';
  import { createEditMachine } from './editMachine';
  export let type:MeetingType;
  const machine = createEditMachine(type);
  const { state, send } = useMachine(machine);
  const save = () => send('SAVE');
  $: values = $state.context.values;
  $: isError = $state.matches('error');
  $: error = $state.context.error;
  $: isSaving = $state.matches('saving');
</script>

<TypeForm on:submit={save} {values} saving={isSaving} />

{#if isError}
  <div class="panel panel-error">
    <p>Tallennus epäonnistui.</p>
    {@html error}
  </div>
{/if}
